import { Divider, Grid } from "@mui/material";

import { useContext } from "react";
import { CustomerFeatureFlagsContext } from "../../../../../contexts/CustomerFeatureFlagsContext";
import CustomNotificationPage from "../../CustomNotificationPage";
import ControlsNotificationsSection from "./ControlsNotificationsSection";
import DetectionsNotificationsSection from "./DetectionsNotificationsSection";
import ScenariosNotificationsSection from "./ScenariosNotificationsSection";

const PageContent = () => {
  const { detectionsActive } = useContext(CustomerFeatureFlagsContext);
  return (
    <>
      {detectionsActive && (
        <>
          <Grid item>
            <DetectionsNotificationsSection />
          </Grid>
          <Divider />
        </>
      )}
      <Grid item>
        <ControlsNotificationsSection />
      </Grid>
      <Divider />
      <Grid item>
        <ScenariosNotificationsSection />
      </Grid>
    </>
  );
};

export default function RiskNotificationsPage() {
  return <CustomNotificationPage title="Risk" PageComponent={PageContent} />;
}
